import React from "react";
import styled from "styled-components";
import img1 from "../../assets/images/aboutus1.jpg";
import img2 from "../../assets/images/aboutus2.jpg";
import img3 from "../../assets/images/aboutus3.jpg";

const AboutUs = () => {
  const Data = [
    {
      img: img1,
      text: " Greetings, I'm DJ Bezi, an open format DJ hailing from London with a rich tapestry of over 15 years in the industry. My journey revolves around cultivating unique and dynamic atmospheres at events, showcasing a passion that spans across a diverse array of music genres, from timeless classics to the forefront of contemporary beats. Marrying the art of mixing and producing, I pride myself on crafting custom beats tailored for each show, ensuring a top-notch entertainment experience that lingers in the memories of the audience. Whether it's an intimate house gathering or an expansive festival, my commitment lies in providing a versatile sonic journey for everyone present. In my firm belief that music should be a universal joy, I'm dedicated to introducing a spectrum of sounds to captivate diverse audiences. Your time exploring my bio is greatly appreciated, and I eagerly anticipate the chance to infuse your world with exceptional music!",
    },
    {
      img: img2,
      text: "We truly appreciate knowing that all your packages are competitively priced, easy to book, and secured with contracts. On top of that, the assurance that all equipment is PAT tested provides us with the peace of mind that our entertainment is in safe hands. We are truly impressed with the level of care and attention you put into providing us with a quality experience. Thank you!",
      reverse: true,
    },
    {
      img: img3,
      text: "We're glad to say that we cover all areas around London and the M25. If you need assistance with a request outside of those areas, please don't hesitate to reach out to us. We'd be more than happy to help you find a solution!",
    },
  ];

  return (
    <MainWrap id="aboutus">
      {Data.map((item, idx) => (
        <Wrap key={idx} reverse={item.reverse}>
          <Image src={item.img} alt={`img${idx}`} />
          <Para reverse={item.reverse}>{item.text}</Para>
        </Wrap>
      ))}
    </MainWrap>
  );
};

export default AboutUs;

const MainWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 5px 0;
`;

const Wrap = styled.div`
  width: 80%;
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  justify-content: center;
  align-items: center;

  @media (max-width: 1000px) {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  @media (min-width: 1000px) and (max-width: 1200px) {
    width: 95%;
  }
`;

const Image = styled.img`
  width: 50%;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;

const Para = styled.p`
  width: 50%;
  margin: 40px;
  font-family: "Nova Square", sans-serif;
  color: rgb(192, 192, 192);
  text-align: ${({ reverse }) => (reverse ? "right" : "left")};
  line-height: 130%;

  @media (max-width: 1000px) {
    text-align: center;
    width: 90%;
    margin: 40px 0;
    font-size: 16px;
  }
`;
